import React from 'react';
import CommonFolderBody from '@rd-web-markets/shared/dist/folders_and_files/modal/CommonFolderBody';
export default props => /*#__PURE__*/React.createElement(CommonFolderBody, props);